module.exports = __webpack_public_path__ + "assets/images/userPlaceholder.cc884df9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/kaledo-components/src/assets/img/userPlaceholder.svg
// module id = 2032
// module chunks = 1610